<template>
  <div class="animated fadeIn">
    <app-filtro
      :fechaDesde="fechaDesdeParam"
      :fechaHasta="fechaHastaParam"
      :cliente="cliente"
      :proveedor="proveedor"
      :retencionTipo="retencionTipo"
      :retencionRegimen="retencionRegimen"
      @filtrar="filtrar">
    </app-filtro>
    <!--
      :incluirRetencionesLiquidadas="Boolean(incluirRetencionesLiquidadas)"
    -->

    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card header="Retenciones de Clientes">
            <b-table
              class="registro"
              responsive="sm"
              :busy="tableBusy"
              :items="retenciones"
              :fields="retencionesFields"
              @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(fechaComprobante)="data">
                {{ data.item.fechaComprobante | fecha }}
              </template>
              <template v-slot:cell(importe)="data">
                {{ data.item.importe | moneda(data.item.moneda) }}
              </template>
              <!--
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="imprimir(data.item)">
                  <i class="fa fa-edit"></i>Imprimir</b-dropdown-item>
              </b-dropdown>
            </template>
            -->
            </b-table>
            <nav>
              <b-pagination
                size="sm"
                :total-rows="totalRegistros"
                :per-page="registrosPorPagina"
                v-model="paginaActual"
                prev-text="Prev."
                next-text="Prox." />
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <app-mensaje :modalMsj="modalMsj" :modalMensaje="modalMensaje" @okAction="okAction" @hiddenAction="hiddenAction" />
  </div>
</template>

<script>
import Filtro from './listFiltro.vue'
import Mensaje from '../shared/msjModal.vue'
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment'
import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: 'retencionesclientes/getField',
  mutationType: 'retencionesclientes/updateField',
})

export default {
  name: 'RetencionesClientes',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
  },
  mixins: [msjModal],
  data() {
    return {
      retencionesFields: [
        {
          key: 'fechaComprobante',
          label: 'Fecha',
        },
        {
          key: 'agenteRetencion',
          // key: 'cliente',
        },
        {
          key: 'retencionTipo',
          label: 'Tipo',
        },
        {
          key: 'retencionRegimen',
          lable: 'Regimen',
        },
        {
          key: 'jurisdiccion',
          lable: 'Jurisdicción',
        },
        {
          key: 'importe',
          class: 'text-right',
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center',
        },
      ],

      loaded: false,
      tableBusy: true,

      retencionSeleccionada: null,
    }
  },
  computed: {
    ...mapFields([
      'retenciones',
      'fechaDesde',
      'fechaHasta',
      'cliente',
      'proveedor',
      'retencionTipo',
      'retencionRegimen',
      'incluirRetencionesLiquidadas',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD')
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD')
    },
  },
  created() {
    this.getItems()
  },
  methods: {
    getItems() {
      this.tableBusy = true
      this.$store
        .dispatch('retencionesclientes/getRetenciones')
        .then(() => (this.tableBusy = false))
        .catch((error) => this.showErrorMsj(error))
    },
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde
      this.fechaHasta = filtro.fechaHasta
      this.cliente = filtro.cliente
      this.proveedor = filtro.proveedor
      this.retencionTipo = filtro.retencionTipo
      this.retencionRegimen = filtro.retencionRegimen
      this.incluirRetencionesLiquidadas = filtro.incluirRetencionesLiquidadas
      this.paginaActual = 1

      this.getItems()
    },
    consultar() {
      /*
      if (this.accesoDatos) {
        this.$router.push({ name: 'RetencionClienteData',
                            params: { id: item.id }});
      }
      */
    },
  },
  watch: {
    paginaActual: function (newVal, oldVal) {
      if (newVal != 0 && oldVal != 0) {
        this.getItems()
      }
    },
  },
}
</script>

<style></style>
